import React from 'react';
import { Grid } from '@mui/material';
import { dropBoolean } from 'utils/drops';
import Input from 'components/Input';
import Dropdown from 'components/Dropdown';

const Filter = ({ grid, control }) => {
  const checkDisplay = (name) => {
    const column = grid?.colunas?.find((c) => c?.field === name);
    if (column?.filterable) {
      return true;
    }
    return false;
  };

  return (
    <Grid container spacing={2}>
      {checkDisplay('id') && (
        <Grid item xs={12}>
          <Input name="id" control={control} label="ID" type="number" />
        </Grid>
      )}
      {checkDisplay('frota') && (
        <Grid item xs={12}>
          <Input name="frota" control={control} label="Nº da Frota" />
        </Grid>
      )}
      {checkDisplay('descricao') && (
        <Grid item xs={12}>
          <Input name="descricao" control={control} label="Descrição" />
        </Grid>
      )}
      {checkDisplay('placa') && (
        <Grid item xs={12}>
          <Input name="placa" control={control} label="Placa" />
        </Grid>
      )}
      {checkDisplay('marca') && (
        <Grid item xs={12}>
          <Input name="marca" control={control} label="Marca" />
        </Grid>
      )}
      {checkDisplay('modelo') && (
        <Grid item xs={12}>
          <Input name="modelo" control={control} label="Modelo" />
        </Grid>
      )}
      {checkDisplay('anofab') && (
        <Grid item xs={12}>
          <Input
            name="anofab"
            control={control}
            label="Ano de Fabricação"
            type="number"
          />
        </Grid>
      )}
      {checkDisplay('anoveic') && (
        <Grid item xs={12}>
          <Input
            name="anoveic"
            control={control}
            label="Ano do Veículo"
            type="number"
          />
        </Grid>
      )}
    </Grid>
  );
};

export default Filter;
